var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHosMonitoringIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1171_19060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5565 15.4491H4.799V21.7897H1.5565V15.4491Z",
    stroke: "#212121",
    strokeWidth: 1.12082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69322 11.1737H10.9357V21.7859H7.69322V11.1737Z",
    stroke: "#212121",
    strokeWidth: 1.12082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8338 7.61119H17.0763V21.7829H13.8338V7.61119Z",
    stroke: "#212121",
    strokeWidth: 1.12082
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9836 4.54344V3.98303H19.4232H18.7624L21.6051 1.13838L24.4497 3.98303H23.7895H23.229V4.54344V21.7822H19.9836V4.54344Z",
    stroke: "#212121",
    strokeWidth: 1.12082
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1171_19060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7969,
    height: 22.0008,
    fill: "white",
    transform: "translate(0.996094 0.347656)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosMonitoringIcon);
export default __webpack_public_path__ + "static/media/hos-monitoring-icon.69eac7412723cba2be9da2ade86598a8.svg";
export { ForwardRef as ReactComponent };